import { createContext, useContext } from 'react';

import { TableOfContentFormat, TableOfContentLeaderStyle } from './TableOfContent.type';

interface TableOfContentContextType {
  isAlignRight: boolean;
  isLinkUsed: boolean;
  isPageNumber: boolean;
  leaderStyle: TableOfContentLeaderStyle;
  levels: number;
  tableFormat: TableOfContentFormat;
  setIsAlignRight: React.Dispatch<React.SetStateAction<boolean>>;
  setIsLinkUsed: React.Dispatch<React.SetStateAction<boolean>>;
  setIsPageNumber: React.Dispatch<React.SetStateAction<boolean>>;
  setLeaderStyle: React.Dispatch<React.SetStateAction<TableOfContentLeaderStyle>>;
  setLevels: React.Dispatch<React.SetStateAction<number>>;
  setTableFormat: React.Dispatch<React.SetStateAction<TableOfContentFormat>>;
}

export const TableOfContentContext = createContext<TableOfContentContextType>({
  isAlignRight: false,
  isLinkUsed: false,
  isPageNumber: false,
  leaderStyle: 'none',
  levels: 1,
  tableFormat: 'classic',
  setIsAlignRight: () => undefined,
  setIsLinkUsed: () => undefined,
  setIsPageNumber: () => undefined,
  setLeaderStyle: () => undefined,
  setLevels: () => undefined,
  setTableFormat: () => undefined,
});

export function useTableOfContentContext() {
  return useContext(TableOfContentContext);
}
